import { render, staticRenderFns } from "./PpmIndigenousAncestryOfChild.vue?vue&type=template&id=9f05c934"
import script from "./PpmIndigenousAncestryOfChild.vue?vue&type=script&lang=ts"
export * from "./PpmIndigenousAncestryOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports